/* unplugin-vue-components disabled */import { ElSelect as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx } from "vue";
import { apiGetGSNameList } from '@/api/gsManage';
import { useModel } from '@ultra/share/hooks/index';
export default /*#__PURE__*/_defineComponent({
  __name: 'selectGS',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props, {
    emit: __emit
  }) {
    const gsOptions = ref();
    const props = __props;
    const emits = __emit;
    const gsid = useModel(() => props.modelValue, val => emits('update:modelValue', val));
    const getGSNameList = async () => {
      const res = await apiGetGSNameList({});
      if (res.code === 0) {
        gsOptions.value = res.data;
      }
    };
    onMounted(() => {
      getGSNameList();
    });
    return (_ctx, _cache) => {
      const _component_el_option = __unplugin_components_0;
      const _component_el_select = __unplugin_components_1;
      return _openBlock(), _createBlock(_component_el_select, {
        modelValue: _unref(gsid),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(gsid) ? gsid.value = $event : null),
        filterable: "",
        clearable: "",
        "reserve-keyword": false,
        placeholder: "搜索GS",
        style: {
          "width": "100%"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(gsOptions), item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: `${item.name} (GSID：${item.id})`,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});